<template>
  <div class="two-box">
    <div class="two-top">
      <div class="two-top-left">
        <div>
          <h1>产品中心</h1>
          <span>PRODUCT CENTER</span>
        </div>
      </div>
      <div class="two-top-right">
        <img src="../../../images/mores.png" alt="" />
        <a @click="goxq()">查看更多</a>
      </div>
    </div>
    <div class="two-bottom">
      <dl v-for="(item, index) in list" :key="index">
        <dt>
          <img :src="item.recommend_image" @click="goxq(item.id)" alt="" />
        </dt>
        <dd>
          <h3>{{ item.name }}</h3>
          <a
            href="javascript:;"
            v-for="(i, v) in item.children.slice(0,6)"
            :key="v"
            :class="i.id === currentIndex ? 'active' : ''"
            @mouseenter="mouseOver(i.id)"
            @mouseleave="mouseLeave(i.id)"
            @click="goxq(i.id)"
            >{{ i.name }}</a
          >
          <div class="more-product" @click="goxq(item.id)"><span>更多产品</span></div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: "",
      currentTitleIndex:true,
      list: [],
    };
  },
  methods: {
    mouseOver(index) {
      this.currentIndex = index;
    },
    mouseLeave(index) {
      this.currentIndex = "";
    },
    goBrandDetail(id){
      this.$router.push({path:'/brandDeatil',query:{id}})
    },
    goxq(id) {
      this.$router.push({ path: "/productCenter", query: { opennames:id } });
    }
  },
  created() {
    this.$api.homepage.productCenter().then((res) => {
      this.list = res.data;
    })
  },
};
</script>

<style lang="less" scoped>
.two-box {
  width: 1250px;
  height: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  .two-top {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 68px;
    .two-top-left {
      display: flex;
      cursor: pointer;
      .Titleactive{
        h1{
          color: #A52A2A;
        }
       span{
         color: #A52A2A;
       }
      }
      h1 {
        font-size: 28px;
        font-weight: 700;
        text-align: left;
        color: #333333;
        line-height: 24px;
      }
      span {
        font-size: 20px;
        text-align: left;
        color: #b8b8b8;
        line-height: 41px;
      }
    }
    .two-top-right {
      a {
        font-size: 16px;
        color: #999999;
        line-height: 19px;
        margin-left: 5px;
      }
    }
  }
  .two-bottom {
    flex: 3;
    display: flex;
    margin-top: 62px; 
    dl {
      width: 100%;
      min-height: 480px;
      justify-content: space-around;
      margin: 0px 10px 20px 10px;
      position: relative;
      dt,img {
        width: 100%;
        height: 115px;
        cursor: pointer;
      }
      dd {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        h3 {
          width: 100%;
          text-align: center;
          height: 50px;
          line-height: 50px;
          font-size: 20px;
          color: #000;
        }
        a {
          font-size: 16px;
          text-align: left;
          line-height: 40px;
          display: block;
          color: #696969;
          text-align: center;
        }
        .active {
          color: #A52A2A;
        }
        .more-product {
            text-align: center;
            line-height: 40px;
            margin: auto;
            margin-top: 20px;
            color:#fff;
            font-size:14px;
            height:40px;
            width:100px;
            background: #013972;
            border-radius: 5px;;
            cursor: pointer;
            position:absolute;
            bottom:5px;
            left:32%;
        }
      }
    }
  }
}
</style>